import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { Login } from "./pages/Login";
import Users from './pages/Users'
import Groups from './pages/Dashboard'
import { useAuthentication } from "./context/authentication";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core'
import Account from "./pages/Account";
export const App = () => {
  const { isFetchingUser, isLogged } = useAuthentication();

  if (!isLogged && isFetchingUser)
  return  <Box display='flex' justifyContent='center' alignItems='center' flex='1'><CircularProgress /></Box>;

  return isLogged ? <AuthenticatedApp /> : <UnauthenticatedApp />;
};

const AuthenticatedApp = () => {
  const { isLogged, user } = useAuthentication();

  if (!isLogged) return <Redirect to="/login" />;

  return (
    <Switch>
      <Route path='/' exact>
          {user.email === 'admin@gmail.com'?<Users />:        <Groups />}
      </Route>
        <Route path="/account" exact>
            <Account/>
        </Route>
      <Route path="*">Error 404 - Page not found!</Route>
    </Switch>
  );
};

const UnauthenticatedApp = () => {
  return (
    <Switch>
      <Route exact path={["/", "/login"]}>
        <Login />
      </Route>
    </Switch>
  );
};
